import { Component, ViewChild,  ElementRef, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';

import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import * as XLSX from 'xlsx';

import { GestockService } from '../services/gestock.service';

import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-inventaire',
  templateUrl: './inventaire.component.html',
  styleUrls: ['./inventaire.component.css']
})
export class InventaireComponent implements OnInit {


	retourClientWS : any ;

    samacaabiyoonwii = "" ;
    porteeUser : any = "" ;

    allPoints = [] ;

    tousLesDepots = [] ;

    choosedPoint = "" ;

    makepost : any ;

	categories: string[] = [] ; 

	choosenCateg = "" ;

	ecarts: any[] = [];

	products : any[] = [] ;

	leStock = [] ;

	didChooseADepot = false ;

	leStockAdjustSyst = [] ;

	TheIncomingExcelData : any[] ;

  	nbrePrdAjust = 0 ;
  	totalEcart = 0 ;
  	totalValeurMonEcart = 0 ;

	boutiques: any; //string[] = ['Toutes', 'Boutique A', 'Boutique B'];
	selectedBoutique: string = 'Toutes';

 
    @ViewChild('fileInput') fileInput!: ElementRef;

	@ViewChild('spinnerDialog', { static: false }) spinnerDialog: TemplateRef<any>;
	spinnerDialogRef : any ;

	@ViewChild('successDialog', { static: false }) successDialog: TemplateRef<any>;
	@ViewChild('failureDialog', { static: false }) failureDialog: TemplateRef<any>;
	finalDialogRef : any ;



  constructor(private dialog: MatDialog, private snackBar: MatSnackBar,
				private configServer: GestockService,  private viewContainerRef: ViewContainerRef) { 
  }

  ngOnInit(): void {
	  this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;
    this.porteeUser =  sessionStorage.getItem("portee") ;
    this.getAllPoints(); 

	  console.log("T", this.choosedPoint) ;
  }




  getAllPointsEtDepots(){
    this.configServer.getAllPointsEtDepots(this.samacaabiyoonwii, this.selectedBoutique).then( (retourbi) => {	  
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      console.log("DEpotYI: ", this.retourClientWS.data) ;
      if(statutreq==1){
        this.allPoints = this.retourClientWS.data ;
        this.retenirJusteLesDepots() ; 
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }

  getAllPoints(){

    this.configServer.getAllPoints(this.samacaabiyoonwii).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      if(statutreq==1){
        console.log("Done") ;
        this.boutiques = this.retourClientWS.data ; 
        if(this.boutiques.length==1)
          this.selectedBoutique = this.boutiques[0].idPoint ;
		this.getAllCategories() ;
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }

	getAllCategories(){
		this.configServer.getAllCategories(this.samacaabiyoonwii).then( (retourbi) => {
		  this.retourClientWS = retourbi ;
		  console.log(this.retourClientWS.data) ;
		  this.getAllPointsEtDepots() ;

		  var statutreq = this.retourClientWS.statutreq;
		  if(statutreq==1){
		  	for (var i = 0; i < this.retourClientWS.data.length; i++) {
			    this.categories.push(this.retourClientWS.data[i].nomcategorie)  ;
		  	}
		    console.log("Done") ;
		  }
		  else{
		    console.log("Failed") ;
		  }
		}) ;        
	}

  onLieuxStructChange(event){
  	console.log(event);
  	this.didChooseADepot = true ;
    this.choosedPoint = event.value ;    
  }


  onCategChange(event){
    this.choosenCateg = event.value ;    
  }


  retenirJusteLesDepots(){
    for (var i = 0; i < this.allPoints.length; i++) {
      if(this.allPoints[i].type=="Depot"){
        this.tousLesDepots.push(this.allPoints[i]) ;
      }
    }
  }


	onTabChange(event){
		this.choosedPoint = undefined ;
		this.makepost = undefined ;
	}


	triggerFileUpload() {
		this.fileInput.nativeElement.click(); // Ouvre l'explorateur de fichiers
	}


	loadStoAdjustInventaire(){
		this.openSpinnerDialog() ;		  
		this.configServer.getsamastock(this.samacaabiyoonwii, this.selectedBoutique).then( (retourbi) => {			
		  this.closeSpinnerDialog() ;		  
		  this.retourClientWS = retourbi ;
		  var statutreq = this.retourClientWS.statutreq;
		  if(statutreq==1){
		    this.leStockAdjustSyst = this.retourClientWS.data ;
		    this.processData() ;
		    console.log("Done") ;
		  }
		  else{
		    console.log("Failed") ;
		  }
		}) ;        
	}

	loadStock(){
		this.openSpinnerDialog() ;		  
		this.configServer.getsamastock(this.samacaabiyoonwii, this.selectedBoutique).then( (retourbi) => {			
		  this.closeSpinnerDialog() ;		  
		  this.retourClientWS = retourbi ;
		  var statutreq = this.retourClientWS.statutreq;
		  if(statutreq==1){
		    this.leStock = this.retourClientWS.data ;
		    this.getTheProducts() ;
		    console.log("Done") ;
		  }
		  else{
		    console.log("Failed") ;
		  }
		}) ;        
	}


	getTheProducts(){
		let depotBi = this.choosedPoint ;
		let categBi = this.choosenCateg ;
		this.products = [] ;
		let allNames = [] ;
		for (var i = 0; i < this.leStock.length; i++) {
			if(depotBi=="all"){
				if( categBi==undefined || categBi=="all")
					this.updateTheLineInfos(this.products.length, this.leStock[i]) ;
				else
					if(this.leStock[i].categorie==categBi)
						this.updateTheLineInfos(this.products.length, this.leStock[i]) ;

			}else{
				if(this.leStock[i].depot_nom==depotBi){
					if(categBi==undefined || categBi=="all")
						this.updateTheLineInfos(this.products.length, this.leStock[i]) ;
					else
						if(this.leStock[i].categorie==categBi)
							this.updateTheLineInfos(this.products.length, this.leStock[i]) ;					
				}
			}
		}

	    this.downloadModeleExcel();
	}


	updateTheLineInfos(indexToUpdt, LaLigneEnStock){
		let baseElt = { "Code Article": "P0"+LaLigneEnStock.article_id.toString(), "Nom Produit": LaLigneEnStock.nom_article, 
						"Dépôt": LaLigneEnStock.depot_nom, 
						"Quantité Physique": "", "Observation": "" } ;
		this.products.push(baseElt) ;	
	}


  downloadModeleExcel() {
    console.log(this.products) ;

    let data = this.products ;
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Inventaire');
    XLSX.writeFile(wb, 'fiche_inventaire_'+this.choosedPoint+'_'+this.choosenCateg+'.xlsx');
  }



  handleFileInput(evt: any) {
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) return;

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws);
      this.TheIncomingExcelData = data;
      this.loadStoAdjustInventaire() ;
      //this.processData(data);
    };
    reader.readAsBinaryString(target.files[0]);

  }

  processData() {
  	this.nbrePrdAjust = 0 ;
  	this.totalEcart = 0 ;
  	this.totalValeurMonEcart = 0 ;

  	let data = this.TheIncomingExcelData ;
    this.ecarts = data.map(row => {
      const lArtticle = this.getArticleDuDepot(row['Dépôt'], row['Code Article']) ;
      const stockSyst = Number(lArtticle.qte_en_stock ) ;
      const cmupArt = Number(lArtticle.cmup ) ;
      const ecart = Number( (row['Quantité Physique'] || 0) - stockSyst ) ;

      const categArt = lArtticle.categorie ;

      if(ecart!=0){
      	this.nbrePrdAjust++ ;
      	this.totalEcart += ecart ;
      	this.totalValeurMonEcart += ecart*cmupArt ;
      }

      const valEcart = Number(ecart)*Number(cmupArt) ; 
      return {
        code: row['Code Article'],
        produit: row['Nom Produit'],
        depot: row['Dépôt'],
        categ: categArt,
        stockSysteme:  stockSyst,/* row['Stock Système']*/
        physique: row['Quantité Physique'],
        ecart: ecart,
        valeurEcart: valEcart,
        observation: row['Observation'] || ''
      };
    });
  }

  getArticleDuDepot(nomDepot, codeArticle){
	for (var i = 0; i < this.leStockAdjustSyst.length; i++) {
		if(this.leStockAdjustSyst[i].depot_nom==nomDepot){
			if("P0"+this.leStockAdjustSyst[i].article_id.toString()==codeArticle)
				return this.leStockAdjustSyst[i] ;
		}
	}
  }

  adjustInventaire(){
	this.openSpinnerDialog() ;		  
	this.configServer.adjustInventaire(this.samacaabiyoonwii, this.ecarts, 
							this.choosedPoint, this.choosenCateg, this.nbrePrdAjust, this.totalEcart, this.totalValeurMonEcart).then( (retourbi) => {			
	  this.closeSpinnerDialog() ;		  
	  this.retourClientWS = retourbi ;
	  var statutreq = this.retourClientWS.statutreq;
	  if(statutreq==1){
	  	this.ecarts = [] ;
	  	this.makepost = undefined ;
	  	this.didChooseADepot = false ;
	  	this.choosedPoint = "" ;
	  	this.choosenCateg = "" ;
	  	this.openSuccesDialog();
	    console.log("Done") ;
	  }
	  else{
	  	this.openFailureDialog() ;
	    console.log("Failed") ;
	  }
	}) ;        
  }



  getMontantFormatee(montant){
    let resultd = Number(montant).toLocaleString('fr-FR');
    return resultd ;
  }


  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog, {viewContainerRef: this.viewContainerRef}) ; 
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }

  openSuccesDialog() {
    this.finalDialogRef = this.dialog.open(this.successDialog, {viewContainerRef: this.viewContainerRef}) ; 
  }

  openFailureDialog() {
    this.finalDialogRef = this.dialog.open(this.failureDialog, {viewContainerRef: this.viewContainerRef}) ; 
  }

  close(){
    this.finalDialogRef.close();
  }


} 

